import { useCallback, useEffect, useState } from 'react';
import { useReactiveVar } from '@apollo/client';

import { filterParams, setUserLocation } from '../graphql/ecp-locator/ecp-locator.cache';
import { ecpLocatorApi } from '../rest/ecp-locator';
import { filteringByStores } from '../utils/ecp-locator';
import { useEcpUserLocation } from '../graphql/ecp-locator/actions/user-location';
import { DEFAULT_RANGE } from '../constants/ecp-locator';
import { setOrderStores } from '../graphql/order/order.cache';
import {
  retailerShopTypeItems,
} from '../components/business/app/ecp-filters-modal';
import { UpdateStores } from '../models';

export const useUpdateOrderStores = () => {
  const { setEcpUserLocationToCache } = useEcpUserLocation();
  const currentFilters = useReactiveVar(filterParams);
  const userLocationCurrent = useReactiveVar(setUserLocation);
  const [isStoresLoading, setLoadingState] = useState(false);
  const [isStoresError, setErrorState] = useState(false);

  const updateStores = useCallback(async ({ userLocation }: UpdateStores) => {
    let userLocationApplied = userLocationCurrent;

    if (userLocation) {
      userLocationApplied = userLocation;
    }

    const { specializations, shops } = currentFilters;
    const { latitude, longitude } = userLocationApplied;

    try {
      setLoadingState(true);
      const { data } = await ecpLocatorApi.getStores({
        lat: latitude,
        long: longitude,
        range: DEFAULT_RANGE,
        sorting: 'rating',
        speciality: specializations.join(','),
        type: '',
        c2cActivated: true,
      });

      if (userLocation) {
        setEcpUserLocationToCache(userLocation);
      }

      setOrderStores(filteringByStores(data, shops, retailerShopTypeItems.length));
    } catch {
      setErrorState(true);
    }
    setLoadingState(false);
  }, [
    currentFilters,
    userLocationCurrent,
    setOrderStores,
    setEcpUserLocationToCache,
  ]);

  useEffect(() => () => {
    setLoadingState(false);
  }, []);

  return { updateStores, isStoresLoading, isStoresError };
};
